export const API_ENDPOINTS = {
         HOSTNAME: {
           LOCAL: 'localhost',
           DEV: 'guest.dealer.dev.toyota.com',
           TEST: 'guest.dealer.test.toyota.com',
           QA: 'guest.dealer.qa.toyota.com',
           E2E: 'guest.dealer.e2e.toyota.com',
           STAGE: 'guest.dealer.stage.toyota.com',
           PROD: 'guest.dealer.toyota.com'
         },
         RTI_ENDPOINT: {
           DEV: 'https://api.rti.dev.toyota.com',
           TEST: 'https://api.rti.test.toyota.com',
           QA: 'https://api.rti.qa.toyota.com',
           E2E: 'https://api.rti.e2e.toyota.com',
           STAGE: 'https://api.rti.stage.toyota.com',
           PROD: 'https://api.rti.toyota.com'
         },
         RTI_X_API_KEY: {
          COMMON: 'x-api-key'
        },
         RTI_X_API_VALUE: {
          DEV: 'b5738aeba1885a239537754f6b3dc53d',
          TEST: 'b5738aeba1885a239537754f6b3dc53d',
          QA: 'b5738aeba1885a239537754f6b3dc53d',
          E2E: 'b5738aeba1885a239537754f6b3dc53d',
          STAGE: 'b5738aeba1885a239537754f6b3dc53d',
          PROD: '9689e6a13e7057cd963cc1ad30788d22'
         },
         CREDIT_APP_ENPOINT: {
          DEV: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
          TEST: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
          QA: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
          E2E: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
          STAGE: 'https://apigateway-stage.toyotafinancial.com/ocainboundservices/oca/services/prefilldata',
          PROD: 'https://apigateway.toyotafinancial.com/ocainboundservices/oca/services/prefilldata'
        },
         PP_ENDPOINT:{
          DEV: 'https://smartpath-stage.toyotafinancial.com',
          TEST: 'https://smartpath-stage.toyotafinancial.com',
          QA: 'https://smartpath-stage.toyotafinancial.com',
          E2E: 'https://smartpath-stage.toyotafinancial.com',
          STAGE: 'https://smartpath-stage.toyotafinancial.com',
          PROD: 'https://smartpath.toyotafinancial.com'
        },
         DIS_ENDPOINT: {
           DEV: 'https://staging.ws.disrest.tms.aws.toyota.com/disrest/',
           TEST: 'https://staging.ws.disrest.tms.aws.toyota.com/disrest/',
           QA: 'https://staging.ws.disrest.tms.aws.toyota.com/disrest/',
           E2E: 'https://staging.ws.disrest.tms.aws.toyota.com/disrest/',
           STAGE: 'https://staging.ws.disrest.tms.aws.toyota.com/disrest/',
           PROD: 'https://www.ws.disrest.tms.aws.toyota.com/disrest/',
           COMMON: 'https://www.ws.disrest.tms.aws.toyota.com/disrest/'
         },
         DIS_API_KEY: {
           COMMON: 'eb072ef59f034a2a94c690fbe5d93274'
         },
         DIS_X_API_KEY: {
           COMMON: 'x-api-key'
         },
         DIS_X_API_VALUE: {
           DEV: 'arWxuE2IUp3tMlsphQmHr5vE1rh8UFSc54z879eh',
           TEST: 'arWxuE2IUp3tMlsphQmHr5vE1rh8UFSc54z879eh',
           QA: 'arWxuE2IUp3tMlsphQmHr5vE1rh8UFSc54z879eh',
           E2E: 'arWxuE2IUp3tMlsphQmHr5vE1rh8UFSc54z879eh',
           STAGE: 'arWxuE2IUp3tMlsphQmHr5vE1rh8UFSc54z879eh',
           PROD: 'fWhQBhcDlQsjMOWuRbuBjSlAseHwdV8NZva2mNdC',
           COMMON: 'fWhQBhcDlQsjMOWuRbuBjSlAseHwdV8NZva2mNdC'
         },
         GOOGLE_MAP_API_KEY: {
          DEV: '',
          TEST: '',
          QA: '',
          E2E: '',
          STAGE: '',
          PROD: '',
          COMMON: ''
         },
         WAF_URL: {
          DEV: 'https://ac33386d318f.us-east-1.sdk.awswaf.com/ac33386d318f/04ed56504143/',
          TEST: 'https://ac33386d318f.us-east-1.sdk.awswaf.com/ac33386d318f/04ed56504143/',
          QA: 'https://ac33386d318f.us-west-2.sdk.awswaf.com/ac33386d318f/76905d35c398/',
          E2E: 'https://b00bbe57dc64.us-east-1.sdk.awswaf.com/b00bbe57dc64/04ed56504143/',
          STAGE: 'https://b00bbe57dc64.us-east-1.sdk.awswaf.com/b00bbe57dc64/04ed56504143/',
          PROD: 'https://b00bbe57dc64.us-east-1.sdk.awswaf.com/b00bbe57dc64/04ed56504143/',
          COMMON: 'https://ac33386d318f.us-east-1.sdk.awswaf.com/ac33386d318f/04ed56504143/'
         },
         PERFORM_APP_DYNAMICS: {
           DEV: false,
           TEST: true,
           QA: true,
           E2E: false,
           STAGE: false,
           PROD: true
         },
         APP_DYNAMIC_KEY: {
           DEV: '',
           TEST: 'AD-AAB-AAN-ZSW',
           QA: 'AD-AAB-AAN-ZSW',
           E2E: '',
           STAGE: '',
           PROD: 'AD-AAB-AAN-YUV'
         }
       };
